import React, { useEffect, useRef, useState } from "react";
import "../../HwManagement/HomeWork/HomeWork.css";
import "./SelfAssessment.css"
import SubjBoxProps from "../../HwManagement/HomeWork/Subj_Box/SubjBoxProps";
import { Button, Popup } from "semantic-ui-react";
import FilterBox from "../../HwManagement/PreRead/Filter_Box/FilterBox";
import PendingSA from "./Pending/PendingSA";
import Completed from "./Completed/CompletedSA";
import SortedBy from "../../HwManagement/PreRead/Filter_Box/SortedBy";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import HWTour from "../../SidebarHeader/Header/HWTour";
import GenerateAssessment from "./GenerateAssessment";
import axios from "./../../axios";
import CompletedSA from "./Completed/CompletedSA";
import { toast } from "react-toastify";
import SeflCreatedSuccess from "./Popup/SelfCreatedSuccess";
import SelfAssessmentTour from "../../SidebarHeader/Header/SelfAssessmentTour";

export default function SelfAssessment({ type }) {
  const subMenu = localStorage.getItem("hwSubMenu")
  const breathForStudent = localStorage.getItem("breathForStudent")
  const [homeMain, setHomeMain] = useState({
    subMenu: subMenu || "pending",
    homeworkData: null,
  });
  const popupRef = useRef(null);
  const [selfAssessmentCreated, setSelfAssessmentCreated] = useState(false);
  const summarySideMenuActive = localStorage.getItem("summarySideMenu");
  const footerActive = localStorage.getItem("footerActive");
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSortPop, setIsSortPop] = useState(false);
  const [summarySideMenu, setSummarySideMenu] = useState(null);
  const [newSelfAssment, setNewSelfAssment] = useState(null);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] = useState(false);

  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupSelfAssessment");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupSelfAssessment", "true");
    }
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    console.log(show);
    setShow(false)
  };
  const handleShow = () => setShow(true);

  const togglePopup = () => {
    setIsSortPop(!isSortPop);
  };

  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".digitalClass",
      intro: `
        <h3>Digital.Class</h3>
        <p>Digital.Class has 3 features (as shown in left most pane):
       </p>
       <ol>
          <li>Summary</li>
          <li>Assessment</li>
          <li>Self.Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneDC",
      intro: `
        <h3>Features Group Left Pane
        Digital.Class has 3 features as shown:</h3>
        <ol>
        <li>Summary</li>
        <li>Assessment</li>
        <li>Self.Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".selfAssessment",
      intro: `
        <h3>Self.Assessment</h3>
        <p>Currently 'Self.Assessment' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsAssessment ",
      intro: `
        <h3>Today and Other Assessments</h3>
        <p>You can see self.assessmments under today and other section.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingSelfAssessment",
      intro: `
        <h3>Pending</h3>
        <p>In this tab you will find Self.Assessments which needs to be submitted by you.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedSelfAssessment",
      intro: `
        <h3>Completed</h3>
        <p>You will find your submitted self-assessments which are reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".filterAssessment",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject time and date wise.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByAssessment",
      intro: `
        <h3>Sort By</h3>
        <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);

  const onExit = () => {
    setStepsEnabled(false);
  };

  const [rotation, setRotation] = useState(0);

  const rotateImage = () => {
    setRotation((rotation) => rotation + 180);
  };


  const toggleFilterPopup = () => {
    // setIsPopupOpen(!isPopupOpen)
    setIsPopupOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 10,
    page: 1,
  });

  return (

    <div className="">
      {show ? <GenerateAssessment handleClose={handleClose} studentInfo={JSON.parse(breathForStudent)} setNewSelfAssment={setNewSelfAssment} setSelfAssessmentCreated={setSelfAssessmentCreated} /> : null}
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />

      <div className="headingOfHW mt-2 d-flex justify-content-between">
        <div className="text-2xl font-semibold text-blue-950">Subject wise Self Assessment</div>
        <button className="btn sa-create py-2" onClick={handleShow}>Generate Self-Assessment</button>
      </div>
      <div className="subjectBoxContainer mt-3 subWiseHW">
        <SubjBoxProps type="SA" newSelfAssment={newSelfAssment} />
      </div>

      <div className="homeWorkSubContainer  ">
        <div className="d-flex">
          <div className="d-flex mt-3 col-2 p-0 HomeWorkSubPartsMenuTotal">
            <div
              className={
                homeMain.subMenu === "pending"
                  ? "HomeWorkSubPartsMenuActive pendingHW"
                  : "HomeWorkSubPartsMenu pendingHW"
              }
              onClick={() => { setHomeMain({ subMenu: "pending" }); localStorage.setItem("hwSubMenu", "pending") }}
            >
              Pending
            </div>

            <div
              // className='HomeWorkSubPartsMenu d-flex justify-content-center'
              className={
                homeMain.subMenu === "Completed"
                  ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedHW"
                  : "HomeWorkSubPartsMenu d-flex justify-content-center completedHW"
              }
              onClick={() => { setHomeMain({ subMenu: "Completed" }); localStorage.setItem("hwSubMenu", "Completed") }}
            >
              Completed
            </div>
          </div>
          <div className="col-1"></div>
          <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
            <div className="mb-3 filterHW">
              <div
                className="col-md-12 gap-2 filter_box"
                onClick={toggleFilterPopup}
              >
                <img
                  className="filter_icon"
                  src="/HwImg/filter Icon.svg"
                  alt=""
                />
                <span>Filter</span>
              </div>
              {/* <Popup
                on="click"
                className="popUpFilter_ass"
                open={isPopupOpen}
                trigger={

                }
                content={

                }
                position="bottom center"
              /> */}
            </div>
            <div
              className="d-flex gap-2 align-items-center  mb-3 sortByHW relative"
              style={{ cursor: "pointer" }}
              onClick={() => {
                togglePopup()
                rotateImage()
              }}
            >
              <div className="sortby">Sort by</div>
              <div>
                <img
                  src="/HwImg/DownArrowSort.png"
                  alt=""
                  style={{ transform: `rotate(${rotation}deg)` }}
                ></img>
              </div>
            </div>

            {/* <Popup
              on="click"
              open={isSortPop}
              onClose={togglePopup}
              onOpen={togglePopup}
              className="popUpFilter_ass"
              trigger={

              }
              content={ }
              position="bottom center"
            /> */}
          </div>
        </div>

        <div className="orange-scrollBar"
          style={{ maxHeight: "50vh", overflowY: "scroll", paddingBottom: "5px" }}
        >
          {homeMain.subMenu === "pending" && (
            <PendingSA
              setFilter={setFilter}
              filter={filter}
              activeMenu={summarySideMenu}
              setHomeMain={setHomeMain}
              newSelfAssment={newSelfAssment}
            />
          )}
          {homeMain.subMenu === "Completed" && (
            <CompletedSA
              setFilter={setFilter}
              filter={filter}
              activeMenu={summarySideMenu}
              setHomeMain={setHomeMain}
            />
          )}
        </div>
      </div>
      {
        selfAssessmentCreated && <SeflCreatedSuccess setNewSelfAssment={setNewSelfAssment} setSelfAssessmentCreated={setSelfAssessmentCreated} />
      }
      {
        homeScreenWalkThroughPopup && (
          <SelfAssessmentTour
            setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
            setStepsEnabled={setStepsEnabled}
          />
        )
      }
      {
        isPopupOpen && (
          <div ref={popupRef}>
            <FilterBox
              setFilter={setFilter}
              filter={filter}
              toggleFilterPopup={toggleFilterPopup}
            />
          </div>
        )
      }
      {
        isSortPop && (
          <SortedBy filter={filter} type={type} setFilter={setFilter} togglePopup={togglePopup} />
        )
      }
    </div>
  );
}
